import { SopformImage } from './SopformImage';

export interface Sopform {
  id: number;
  userId: number | null;
  deliveryId: number | null;
  damageLeaks: boolean | null;
  lightsSignalsBrakes: boolean | null;
  safetyEquipmentPpe: boolean | null;
  dateCreated: string | null;
  damageLeaksNotes: string | null;
  lightsSignalsBrakesNotes: string | null;
  safetyEquipmentPpenotes: string | null;

  // public virtual Delivery? Delivery: boolean | null;

  // public virtual User? User: boolean | null;

  sopformImages: SopformImage[] | null;
}

export enum SopformTypeEnum {
  PreCheck = 1,
  PostCheck = 2,
}
